import { Text, TextProps } from '@chakra-ui/react';

export interface ClipTextProps {
  max?: number;
  text: string | undefined;
  ellipse?: string;
  children?: (props: React.PropsWithRef<{ text: string }>) => JSX.Element;
}

export const ClipText = (
  props: ClipTextProps & Omit<TextProps, 'text'>
): JSX.Element => {
  const { text = '', max = 128, children, ellipse = '...', ...other } = props;
  const threshold = max - ellipse.length;

  let actual = (text || '').substring(0, threshold);
  if (actual !== text) {
    actual += ellipse;
  }

  if (children) {
    return children({ text: actual, ...other });
  }

  return <Text {...other}>{actual}</Text>;
};
